import { Component } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrailerService } from 'src/app/services/trailer.service';
import { UtilsService } from 'src/app/services/utils.service';

declare const $: any;

@Component({
  selector: 'app-trailer-edit',
  templateUrl: './trailer-edit.component.html',
  styleUrls: ['./trailer-edit.component.css']
})
export class TrailerEditComponent {
  private idTrailer: number = 0;

  constructor(
    private fb: FormBuilder,
    private utils: UtilsService,
    private spinner: NgxSpinnerService,
    private apiTrailer: TrailerService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.spinner.show()
    this.route.params.subscribe(params => {
      this.idTrailer = params['id']
      this.getDataTrailer(this.idTrailer)
    })
  }

  formModelData: any = {
    trailer: null,
    plate: null,
    year: null,
    trailer_type_id: '',
    active: true
  }

  trailerTypes: any[] = []
  trailerForm!: FormGroup

  ngOnInit(): void {
    this.trailerForm = this.fb.group({
      trailer: ['', Validators.required],
      plate: ['', Validators.required],
      year: ['', Validators.required],
      trailer_type_id: ['', Validators.required],
      active: [true, Validators.required]
    })

    this.apiTrailer.getTrailerTypes().subscribe((resp: any) => {
      this.trailerTypes = resp || []
    })
  }

  getDataTrailer(id: number) {
    this.apiTrailer.getId(id).subscribe((resp: any) => {
      this.formModelData = resp
      if (this.formModelData && this.formModelData.trailer_type) {
        this.formModelData.trailer_type_id = this.formModelData.trailer_type.id
      } else {
        this.formModelData.trailer_type_id = ''
      }
      this.spinner.hide()
    })
  }

  updateTrailer() {
    if (this.trailerForm.valid) {
      this.spinner.show()
      const payload: any = { ...this.formModelData }
      payload.active = payload.active ? '1' : '0'

      this.apiTrailer.updateTrailer(payload, this.idTrailer).subscribe((resp: any) => {
        this.spinner.hide()
        this.utils.alertSwal({ title: 'Exitoso', text: resp.msg, icon: 'success' })
          .then(() => {
            this.router.navigateByUrl('/trailer/list')
          })
      }, () => {
        this.spinner.hide()
        this.utils.alertSwal({ title: 'Error!', text: 'Se ha presentado un error al actualizar el remolque', icon: 'error' })
      })
    } else {
      this.utils.alertSwal({ title: 'Advertencia', text: 'Verifique que la información se encuentre completa.', icon: 'warning' })
    }
  }

  goToChecklist() {
    this.router.navigateByUrl('/unit/checklist', { state: { data: this.formModelData } });
  }

  get registerFormControl() {
    return this.trailerForm.controls;
  }
}
